import React from 'react'

import './styles.scss'
import LookingForButton from '../LookingForButton'
import { lang } from 'utils/helpers'
import { buttonsType } from './utils'

const LookingFor = ({ handleSearch }) => (
  <div className='search-engine-looking-for'>
    <p className='search-engine-looking-for__title'>{lang('dashboard_im-looking')}</p>
    <div className='search-engine-looking-for__content'>
      {buttonsType.map((type, index) => (
        <LookingForButton key={index} type={type} handleSearch={handleSearch} />
      ))}
    </div>
  </div>
)

export default LookingFor
